import useIntl from '@/utils/intl'
import { ArrowForwardIos } from '@mui/icons-material'
// import { useRouter } from 'next/navigation'
import React, { FunctionComponent } from 'react'
import { Obj } from '.'
import { useRouter } from 'next/navigation'

interface Props {
  onClick: (objs: Obj) => void
  danRedirectUrl: string
}

const Step2: FunctionComponent<Props> = ({ onClick, danRedirectUrl }) => {
  const router = useRouter()
  const { translate } = useIntl()
  return (
    <div className='w-full md:h-[75vh] h-screen flex flex-col md:justify-center items-center p-4'>
      <div className='md:bg-surfaceInverse md:p-4 rounded-3xl'>
        <span className='text-textHigh font-extrabold text-lg'>{translate('user.authentication')}</span>
        <p className='text-textMid text-sm mt-2'>{translate('user.confirmInfo')}</p>
        <div className='bg-surfaceInverse rounded-2xl flex flex-col items-start justify-center gap-4 mt-6'>
          <div onClick={() => router.push(danRedirectUrl)} className='md:w-96 p-3 border border-secondaryMidStroke rounded-xl flex items-center justify-between w-full cursor-pointer'>
            <div>
              <div className='flex items-center gap-2'>
                <img src='/icons/e-mongolia.png' className='w-8 h-8' alt='mobot' />
                <span className='font-bold text-textHigh'>e-Mongolia</span>
              </div>
              <p className='text-textMid text-xs mt-2'>{translate('dan.requirement')}</p>
            </div>
            <ArrowForwardIos fontSize='small' className='text-textMid' />
          </div>
        </div>
      </div>
    </div>

  )
}
export default Step2
